import * as React from 'react';

import './Spinner.scss';

const Spinner: React.FC = () => (
  <div className="spinner-wrapper">
    <div className="lds-spinner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export { Spinner };
